module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2020_fr-020909874a4de5e7772b7881dccbeb78.jpg";